import {createContext,useContext,useState} from 'react';
import {Backdrop,CircularProgress,Box,Typography} from '@mui/material';

const LoadingContext=createContext();
export const useLoading=()=>useContext(LoadingContext);

export const LoadingProvider=({children})=>{
  const [loading,setLoading]=useState(false);
  const [progress,setProgress]=useState(null);

  const showLoading=(value=null)=>{
    setProgress(typeof value==='number'?Math.max(0,Math.min(100,value)):null);
    setLoading(true);
  };

  const updateProgress=(value)=>{
    setProgress(typeof value==='number'?Math.max(0,Math.min(100,value)):null);
  };

  const hideLoading=()=>{
    setLoading(false);
    setProgress(null);
  };

  return (
    <LoadingContext.Provider value={{loading,showLoading,hideLoading,updateProgress}}>
      {children}
      {/* Popup.js's own overlay sits at zIndex 1300 (MUI's "modal" level) - anything that calls
          showLoading() while a popup is open (e.g. PageDetail's save flow in isPopUp mode, or
          AttachmentUploadPopup's upload) needs this Backdrop above that, or the spinner renders
          invisibly behind the popup and an upload/save just looks like nothing is happening. */}
      <Backdrop
        sx={{color:'#fff',zIndex:1350}}
        open={loading}>
        <Box sx={{textAlign:'center'}}>
          <CircularProgress
            color="inherit"
            size={100}
            variant={progress !== null ? 'determinate' : 'indeterminate'}
            value={progress ?? undefined}/>
          {progress!==null&&(
            <Typography variant="h5" sx={{mt:1}}>{progress}%</Typography>
          )}
        </Box>
      </Backdrop>
    </LoadingContext.Provider>
  );
};